const state = {
  navIndex: Number(sessionStorage.navIndex),
  userRole: 1
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js